import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class TimeService extends Service {
  @tracked now = Date.now();
  #nowInterval = null;

  constructor() {
    super(...arguments);
    this.#nowInterval = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  }

  willDestroy() {
    super.willDestroy(...arguments);
    clearInterval(this.#nowInterval);
  }
}
